import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { AuthGuardService, UserService } from '@core/services';

@Component({
  selector: 'app-edit-toll-pass',
  templateUrl: './edit-toll-pass.component.html',
  styleUrls: ['./edit-toll-pass.component.css']
})

export class EditTollPassComponent implements OnInit, OnDestroy {

  public passId: number;
  editPass: FormGroup;
  private user: any;
  private subscription: Subscription;
  public oldPassName: string;


  constructor(public dialogRef: MatDialogRef<EditTollPassComponent>,
              private authGuard: AuthGuardService,
              private _service: UserService) {
    this.editPass = new FormGroup({
      PassName: new FormControl('', [Validators.required]),
    });

  }

  ngOnInit() {
    this.subscription = this._service.getUser().subscribe(user => {
      this.user = user;
    });

    this.oldPassName = this.user.accountPassArray[this.dialogRef.componentInstance.passId].name;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit(): void {
    this.authGuard.authenticatedPost('/portfolios/UpdateAccountCard', this.setupEditPassData()).subscribe(
      result => {
        console.log('edit pass result:', result);
        this.dialogRef.close(true);
      },
      error => console.log('Edit pass Error:', error)
    );
    console.log('Value submitted:', this.editPass.value.PassName);
    console.log('Pass Id submitted:', this.dialogRef.componentInstance.passId);
  }

  private setupEditPassData() {
    return {
      'CardId': this.user.accountPassArray[this.dialogRef.componentInstance.passId].id,
      'CardName': this.editPass.value.PassName,
      'AccountId': this.user.accountSummaryArray[this.user.accountIndex].id
    };
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/edit-toll-pass/edit-toll-pass.component.ts